export default {
  caseinfo: '案件資訊',
  intro: '此功能使用AI技術展示判案書的主要資料，請擊點閱讀相關資訊。部分資料只有英文版。歡迎填寫意見表格提供意見及回報錯誤。',
  case_disclaimer: '* 本欄的資訊來自案件所有的判決書',
  pi: {
    title: '損害賠償資訊 (PSLA)',
    background: {text:"原告人背景"},
    age_accident: {text:'意外發生時歲數'},
    age_trial:  {text:'審訊時歲數'},
    gender: {text:'性別'},
    male: '男性',
    female:'女性',
    occupation_bef:{text:'意外前職業'},
    occupation_aft_actual:{text:'意外後職業'},
    injuries: {text:'傷勢摘要'},
    injury_type: {text:'傷勢的嚴重程度'},
    disaster: '災難',
    gross: '嚴重殘疾',
    substantial: '重大受傷',
    serious: '嚴重受傷',
    nonserious: '一般受傷',
    loss: {text:'失去的生活樂趣'},
    loss_walk: '喪失步行的能力或視力',
    loss_limb: '喪失肢體或其功能',
    loss_congenial_emp: '失去適宜的工作',
    loss_pride_pleasure: '失去對自己的工作的自豪感和樂趣',
    loss_marriage: '失去婚姻前景',
    loss_breakdown_family: '家庭破裂',
    loss_sexual_function: '喪失性功能',
    loss_sexual_interest: '對性失去興趣',
    loss_give_birth: '喪失生育能力',
    loss_natural_childbirth: '喪失自然分娩的能力',
    loss_mental_ability: '喪失精神或心理能力',
    loss_personality: '人格改變',
    loss_life_expectation: '預計壽命損失',
    loss_confidence_public: '對在公眾場合外出失去自信心',
    loss_grandchildren: '喪失照顧兒孫的樂趣',
    loss_children: '喪失親子玩樂的樂趣',
    loss_pleasure_parenthood: '被剝奪父母養育子女的樂趣',
    loss_social_activities: '失去參與社交活動、運動及興趣的能力',
    loss_rewarding_occupation: '喪失從事有價值和愉快的職業的能力',
    loss_family_social_pleasure: '喪失天倫之樂及社交情誼',
    comparable_cases: {text:'同類案例'},
    more_serious: {text:'比本案傷勢較重'},
    similar: {text:'接近本案的傷勢'},
    level_unspecified: {text: '未有標示傷勢'},
    less_serious: {text:'比本案傷勢較輕'},
    psla_amount: {text:'損害賠償金額', unit:'$ {n}'},
    treatment_type_received:{text: '接受的治療'},
  },
  dt:{
    title: '販毒案件',
    selecthint: '選擇被告人以顯示相關資訊',
    f_charge_single: '控罪',
    f_charge: '第{0}項控罪',
    f_defendant_single: '被告人',
    f_defendant: '第{0}被告人',
    charge_name: {text: '控罪'}, //'罪名'
    drugs: {text: '毒品種類及重量', default_unit: '{n} 克'},
    cocaine: {text: '可卡因', unit:  '{n} 克'},
    heroin: {text: '海洛英', unit: '{n} 克'},
    methamphetamine: {text: '冰毒', unit: '{n} 克'},
    ketamine: {text: '氯胺酮', unit: '{n} 克'},
    nimetazepam: {text: '硝甲西泮', unit: '{n} 克'},
    ecstasy: {text: '搖頭丸', unit: '{n} 克'},
    cannabisresin: {text: '大麻精', unit: '{n} 克'},
    herbalcannabis: {text: '大麻草', unit: '{n} 克'},
    aggravate: {text: '加刑因素', unit: '+{n} 個月'},
    refugee: {text: '難民申請人', unit: ' | +{n} 個月 | +{n} 個月'},
    bail: {text: '保釋期間犯罪', unit: ' | +{n} 個月 | +{n} 個月'},
    street: {text: '於街上販運毒品', unit: ' | +{n} 個月 | +{n} 個月'},
    persistent: {text: '慣犯', unit: ' | +{n} 個月 | +{n} 個月'},
    international: {text: '跨境販毒', unit: ' | +{n} 個月 | +{n} 個月'},
    aggravating_others: {text: '其他加刑因素', unit: ' | +{n} 個月 | +{n} 個月'},
    //totalagg: {text: 'Total sentence added for aggravating factors', unit: '+{n} 個月'},
    sentence: {text: '刑期', unit: '{n} 個月'},
    training_centre: '敎導所令',
    detention_centre: '勞敎中心令',
    addiction_treatment_centre: '戒毒所令',
    probation_order: '感化令',
    rehabiltation_centre_order: '更生中心令',
    guilty_plea: {text: '認罪'},
    guilty_plea_stage: {text: '階段'},
    guilty_plea_sentence_str: {text: '扣減', unit: '"{n}"'},  // string
    guilty_plea_sentence_month: {text: '扣減', unit: '扣減 {n} 個月'},  // months
    guilty_plea_sentence_percent: {text: '扣減', unit: '{n}%'},  // percentage
    plea_not_guilty: '不認罪',
    high_unknown: '未有提及',
    high_committal: '裁判法院進行的交付審判程序前',
    high_before_fix_trial_date: '交付審判程序後至排期審訊前',
    high_before_trial: '排期審訊後至首日審訊前',
    high_first_day: '審訊首日',
    high_during_trial: '審訊期間',
    district_unknown: '未有提及',
    district_plea_day: '直至移交區域法院答辯日為止',
    district_before_trial: '排期審訊後至首日審訊期間',
    district_first_day: '審訊首日',
    district_during_trial: '審訊期間',
    mitigate:  {text: '減刑因素'},
    remorse: {text: '被告人有悔意', unit: ' | −{n} 個月 | −{n} 個月'}, 
    self_consume: {text: '自用相當比例毒品', unit: ' | −{n} 個月 | −{n} 個月'},
    controlled_delivery: {text: '協助有關當局', unit: ' | −{n} 個月 | −{n} 個月'},
    testimony: {text: '協助有關當局', unit: ' | −{n} 個月 | −{n} 個月'},
    good_character: {text: '正面良好品格', unit: ' | −{n} 個月 | −{n} 個月'},
    mitigating_others: {text: '其他減刑因素', unit: ' | −{n} 個月 | −{n} 個月'},
    background: {text: '被告人背景'},
    foreigner: '外國人',
    commission_age: {text: '犯案時歲數', unit: '{n}'},
    sentencing_age: {text: '審訊時歲數', unit: '{n}'},
    extreme_youth: '極度年青',
    previous_criminal_records: '有過往刑事紀錄',
    clear_record: '沒有定罪紀錄',
    starting_point: {text: '量刑起點', unit: '{n} 個月'},
    single_charge_penalty: '刑期',
    penalty: {text: '刑罰'},
    unspecified: '未指明',
  }
}